import { Box, Text } from '@factorialco/deprecated-design-system'
import { TrainingsSession } from 'generated/resources/graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { sortSessionsByDateAsc } from 'modules/trainings/hooks/Sessions/useTrainingsSessions'

interface Props {
  sessions: TrainingsSession[]
  accessId: number
}
export const NextSessionLabel = ({ sessions, accessId }: Props) => {
  const mySessions = sessions.filter((session) =>
    session.sessionAttendances.some((sessionAttendance) => sessionAttendance.accessId === accessId)
  )

  const formatDate = (date: string) => {
    if (!date) return i18n.t('trainings.my_training.next_session.self_paced')

    if (Date.parse(date) < Date.now())
      return i18n.t('trainings.my_training.next_session.no_further_sessions')

    return moment(date).format('L HH:mm').toLocaleString()
  }

  const nextSessionDate = mySessions
    ?.slice()
    .sort(sortSessionsByDateAsc)
    .map((session) => session.startsAt)[0]

  const nextSessionDateFormatted = formatDate(nextSessionDate)

  return (
    <Box style={{ display: 'inline-block' }}>
      <Text.Normal>{nextSessionDateFormatted}</Text.Normal>
    </Box>
  )
}
